import { gql } from '@apollo/client'

export const LeaveRoom = gql`
    mutation LeaveRoom($roomId: ID!) {
        leaveRoom(roomId: $roomId) {
            id
            updated
            actor {
                avatar
                created
                email
                id
                invites {
                    id
                    issuer {
                        id
                        username
                    }
                    room {
                        id
                        name
                        owner {
                            id
                            username
                        }
                    }
                }
                rooms {
                    id
                    name
                    topic
                    spinning
                    owner {
                        id
                        username
                    }
                    admins {
                        id
                        username
                    }
                    members {
                        id
                        username
                    }
                }
                storage
                updated
                username
            }
            member {
                avatar
                created
                email
                id
                invites {
                    id
                    issuer {
                        id
                        username
                    }
                    room {
                        id
                        name
                        owner {
                            id
                            username
                        }
                    }
                }
                rooms {
                    id
                    name
                    topic
                    spinning
                    owner {
                        id
                        username
                    }
                    admins {
                        id
                        username
                    }
                    members {
                        id
                        username
                    }
                }
                storage
                updated
                username
            }
            room {
                id
                name
                topic
                spinning
                owner {
                    id
                    username
                }
                admins {
                    id
                    username
                }
                members {
                    id
                    username
                }
            }
        }
    }
`

export default LeaveRoom

